import React from "react";

import { SVGInfoIcon } from "../../svg-animated/svg-animated";
import DocumentStatus from "./document-status";

const DocumentChecking = () => (
    <DocumentStatus
        icon={<SVGInfoIcon/>}
        headingText="Checking your documents"
        paragraphText="Won&apos;t be a moment, just analysing your document 
        uploads to ensure your application goes as smoothly as possible."
        loading={true}
    />
);

export default DocumentChecking;
